/**
 * Created by zhengyf on 2018.1.29.
 *
 * params:
 *  pn: 页码
 *  pn_count: 每页显示的数量
 *  status: 状态 'all' || 'pass' || 'noPass' || 'verifying' || 'draft'
 */

;(function () {

    ProductManageCtrl.$inject = ['request', '$filter', '$q', '$scope', '$timeout', 'CURRENCY'];
    angular.module('DSSXAPP', ['app.core', 'app.extra.lazyLoad']);

    angular
        .module('DSSXAPP')
        .controller('ProductManageCtrl', ProductManageCtrl);

    function ProductManageCtrl(request, $filter, $q, $scope, $timeout, CURRENCY) {

        var vm = this;

        /****************************variable******************************/
        var util = DSSX.util;
        var mainAccountName = '';
        var store = {
            pn: +util.queryString('pn') || 1,
            PAGE_COUNT: +util.queryString('pn_count') || 30,
            status: util.queryString('status') || 'all', // all pass noPass verifying draft
            aimGroup: '',
            singleProd: null,
            beUpdateProducts: [] // 准备更新的产品
        };

        // 搜索、加载相关
        vm.search = {
            completed: false,

            // 分页页码自动补全重试次数
            pagingRetryCount: 0,

            //是否展示高级搜索
            advance: false,

            // params 请求参数
            p: {
                putaway: 'all',
                status: 'verified',
                key: '',
                group: '',
                model: '',
                director: '',
                score: '',
                id: '',
                updateTime: '',
                directlyOrder: '',
                isRts: '',
                showWin: '',
            }
        };

        vm.c = {
            productsNoop: null,
            paginationArgsNoop: null,
            paginationArgs: null, // 分页配置
            completed: false, //加载产品列表状态
            selectAll: false, // 选择全部产品
            showAimGroupsSelect: false, // 显示移动到 的分组列表
            showTip: false, // 遮罩提示
            btnGroupShowIndex: -1, // 要显示的操作列表的index
            dialogContent: {
                type: '',
                tip: ''
            }, // 遮罩提示内容
            leftMenu: [
                {
                    title: '发布产品',
                    href: '',
                    strong: true
                },
                {
                    title: '发布产品',
                    href: 'product-post.html'
                },
                {
                    title: '管理产品',
                    href: '',
                    strong: true
                },
                {
                    title: '管理产品',
                    href: 'product-manage.html',
                    current: true
                },
                {
                    title: '产品分组与排序',
                    href: 'manage-products-group.html'
                },
                {
                    title: '管理橱窗产品',
                    href: 'window-product-manage.html'
                },
                {
                    title: '管理认证产品',
                    href: ''
                },
                {
                    title: '管理优商专区',
                    href: ''
                },
                {
                    title: '关联一达通出口产品',
                    href: ''
                },
                {
                    title: '回收站',
                    href: ''
                },
                {
                    title: '工具中心',
                    href: '',
                    strong: true
                },
                {
                    title: '管理图片银行',
                    href: 'photo-bank.html'
                },
                {
                    title: '管理视频银行',
                    href: ''
                },
                {
                    title: '管理智能编辑详情导航模板',
                    href: ''
                },
                {
                    title: '全文搜索工具',
                    href: ''
                },
                {
                    title: '管理标签',
                    href: ''
                },
                {
                    title: '管理行业商机',
                    href: ''
                },
                {
                    title: '搜索诊断',
                    href: '',
                    strong: true
                },
                {
                    title: '搜索诊断首页',
                    href: ''
                },
                {
                    title: '供应商诊断优化',
                    href: ''
                },
                {
                    title: '关键词诊断优化',
                    href: ''
                },
                {
                    title: '产品诊断优化',
                    href: ''
                },
                {
                    title: '排名查询工具',
                    href: ''
                },
                {
                    title: '学习中心',
                    href: ''
                }
            ],
            topNavTabs: [
                {
                    title: '全部'
                },
                {
                    title: '审核通过'
                },
                {
                    title: '审核不通过'
                },
                {
                    title: '审核中'
                },
                {
                    title: '草稿'
                }
            ],
            pageCountFilter: [
                {
                    number: 10,
                    active: false
                },
                {
                    number: 30,
                    active: false
                },
                {
                    number: 50,
                    active: false
                }
            ],
            advanceConf: { // 高级搜索配置
                putaway: [
                    {label: '所有分组', value: 'all'},
                    {label: '已上架（公共产品）', value: 'yes'},
                    {label: '已下架（私人产品）', value: 'no'}
                ],
                score: [
                    {label: '全部', value: ''},
                    {label: '潜力商品', value: '4-5'},
                    {label: '普通产品', value: '3.5-4'},
                    {label: '低质产品', value: '0-3.5'}
                ],
                updateTime: [
                    {label: '全部', value: ''},
                    {label: '最近7天', value: '7'},
                    {label: '最近30天', value: '30'},
                    {label: '自定义时间段', value: '', disabled: true}
                ],
                productType: [
                    {label: '全部', value: 'all,all'},
                    {label: '直接下单品', value: '1,all'},
                    {label: '--Ready to ship', value: '1,yes'},
                    {label: '--非 Ready to ship', value: '1,no'},
                    {label: '非直接下单品', value: '0,all'}
                ],
                director: [],
            },
            marketId: 'EN',
        };

        vm.d = {
            products: [],
            total: 0,
            defaultProducts: [],
            groups: [],
            groupList: [],
            group: '所有分组',
            keyword: '',
            subAccounts: [],
            showedDefaultProductsNum: 0,
            priceEditor: { // 价格编辑窗相关
                isShow: false,
            },
            currency: CURRENCY,
            advance: { // 高级搜索相关，转格式后再赋值于 vm.search.p 进行搜索
                productType: 'all,all',
                isRts: '',
                showWin: '',
            },
        };

        vm.f = {
            paginationFunc: paginationFunc,
            paginationSyncFunc: paginationSyncFunc,
            toggleNavTab: toggleNavTab,
            setAllProductStatus: setAllProductStatus,
            selectGroupFinish: selectGroupFinish,
            showGroupsMenu: showGroupsMenu,
            searchProducts: searchProducts,
            enterSearch: enterSearch,
            clearSearchContent: clearSearchContent,
            refresh: refresh,
            updateProduct: updateProduct,
            saveSelectedProduct: saveSelectedProduct,
            deleteProductSingle: deleteProductSingle,
            setPageCount: setPageCount,
            selectGroup: selectGroup,
            ctrlAimGroupsList: ctrlAimGroupsList,
            closeTip: closeTip,
            batchDetailProduct: batchDetailProduct,
            showNotReleaseTip: showNotReleaseTip,
            openDeleteTip: openDeleteTip,
            allotProd: allotProd,
            onResetDefaultData: onResetDefaultData,
            resetDefaultData: resetDefaultData,
            batchEditProduct: batchEditProduct,
            showPriceEditor: showPriceEditor,
            ctrlPriceEditor: ctrlPriceEditor,
            setPriceEditorPreview: setPriceEditorPreview,
            checkPriceEditorInput: checkPriceEditorInput,
            updateProductTradeInfo: updateProductTradeInfo,
            changeFilterDirectlyOrder: changeFilterDirectlyOrder,
            clickFilterIsRTS: clickFilterIsRTS,
            changeMarket: changeMarket,
        };

        /**************************function*******************************/

        init();

        function init() {
            console.log('[ProductManageCtrl init: ]');
            loadSubAccountList();
            var index = getActiveTabIndex();
            initSetPageCount();
            toggleNavTab(index, vm.c.topNavTabs[index], true);
            loadMyGroups();
            initDocumentEvent();
            initMousedownListener();
        }

        // 监听鼠标左键，关闭操作列表
        function initMousedownListener() {
            document.onmousedown = function(event) {
                try {
                    if(event.button == 0 && event.target.parentNode.parentNode.className != "next-menu-content") {
                        vm.c.btnGroupShowIndex = -1;
                        $scope.$apply();
                    }
                } catch(e) {
                }
            }
        }

        function getActiveTabIndex() {
            var index;
            switch (store.status) {
                case 'all':
                    index = 0;
                    break;
                case 'pass':
                    index = 1;
                    break;
                case 'noPass':
                    index = 2;
                    break;
                case 'verifying':
                    index = 3;
                    break;
                case 'draft':
                    index = 4;
                    break;
                default:
                    index = 0;
            }

            return index;
        }

        function initSetPageCount() {

            if ([10, 30, 50].indexOf(store.PAGE_COUNT) === -1) {
                store.PAGE_COUNT = 30;
            }

            for (var i = 0; i < vm.c.pageCountFilter.length; i++) {
                vm.c.pageCountFilter[i].active = vm.c.pageCountFilter[i].number === +store.PAGE_COUNT;
            }
        }

        // 切换顶部导航栏tab 更新数据
        function toggleNavTab(index, tab, isRefresh) {

            var pn = 1;

            if (isRefresh) {
                pn = store.pn;
            }

            switch (tab.title) {
                case '全部':
                    store.status = 'all';
                    vm.search.p.status = 'verified';
                    break;
                case '审核通过':
                    store.status = 'pass';
                    vm.search.p.status = 'verified';
                    break;
                case '审核不通过':
                    store.status = 'noPass';
                    vm.search.p.status = 'verify-no-pass';
                    break;
                case '审核中':
                    store.status = 'verifying';
                    vm.search.p.status = 'verifying';
                    break;
                case '草稿':
                    store.status = 'draft';
                    vm.search.p.status = 'draft';
                    break;
                default:
                    return;
            }
            setTopNavTabsActive(index);
            reloadList(pn, store.PAGE_COUNT);
        }

        /**
         * 设置 vm.c.topNavTabs active
         * @param {Number} index
         */
        function setTopNavTabsActive(index) {
            var topNavTabs = vm.c.topNavTabs;
            var tg = topNavTabs[index];
            for (var i = 0; i < topNavTabs.length; i++) {
                topNavTabs[i].active = false;
            }

            if (tg) {
                tg.active = true;
            }
        }

        // 设置 vm.c.topNavTabs number
        function setTopNavTabsNumber(numberList) {

            // 不是有效的参数
            if (!Array.isArray(numberList) || (Array.isArray(numberList) && numberList.length !== 5)) {
                console.warn('[product-manage.js::setTopNavTabsNumber] [numberList] is not a valid argument');
                console.log('[product-manage.js::setTopNavTabsNumber] numberList: ', numberList);
                numberList = [0, 0, 0, 0, 0];
            }

            var topNavTabs = vm.c.topNavTabs;
            for (var i = 0; i < topNavTabs.length; i++) {
                topNavTabs[i].number = numberList[i];
            }
        }

        // 重置 vm.c.topNavTabs 数据
        function resetTopNavTabs() {
            var topNavTabs = vm.c.topNavTabs;
            for (var i = 0; i < topNavTabs.length; i++) {
                topNavTabs[i].active = false;
                topNavTabs[i].number = 0;
            }
        }

        // 分页组件
        /**
         * reload list, 触发分页组件的回调
         * @param {number} [page]. typeof page === 'number' && page > 0 使用该页码, 其他 使用旧页码
         * @param {number} [size]. 每页数量 typeof size === 'number' && size > 0 使用该值，否则使用旧值
         */
        function reloadList(page, size) {
            var old = vm.c.paginationArgs || {
                // 页数
                pn: 1,
                // 每页数量
                ps: store.PAGE_COUNT,
                // 显示最多页数
                pl: 5
            };

            if (typeof page !== 'number' || !(page > 0)) {
                page = old.pn;
            }

            if (typeof size !== 'number' || !(size > 0)) {
                size = old.ps;
            }

            vm.c.paginationArgs = {
                pn: page,
                ps: size,
                pl: old.pl
            };
        }

        /**
         * 分页组件回调
         * @param args . {pn: 1, ps: 10} 每页10条，当前第1页
         * @param success. Function({pa: {total: 12}}) 回调函数
         */
        function paginationFunc(args, success) {
            var search = vm.search;
            var _params = angular.extend({}, search.p, {retVerifiedTotal: 1, retShowWinIds: 1}, {page: args.pn, pageCount: args.ps});
            search.completed = false;
            vm.c.completed = false;
            return loadMyProducts(_params)
                .then(loadListInManagePrd)
                .then(function (data) {
                    var url = location.href;
                    // 如果列表为空，但总数不为0
                    if (!data.list.length && data.total) {
                        var realPage = Math.ceil(data.total / args.ps);
                        // 请求页码大于真实页码，请求最后一页
                        if (args.pn > realPage && realPage >= 1 && search.pagingRetryCount < 3) {
                            search.pagingRetryCount++;
                            reloadList(realPage);
                            return;
                        }
                    } else if (search.pagingRetryCount !== 0) {
                        search.pagingRetryCount = 0;
                    }

                    search.completed = true;
                    vm.c.paginationList = {length: data.list.length};
                    success(({pa: {total: data.total}}));
                    loadListOnStart();
                    loadListOnSuccess(data);

                    url = util.updateUrlSearch(url, 'pn', args.pn);
                    url = util.updateUrlSearch(url, 'pn_count', args.ps);
                    url = util.updateUrlSearch(url, 'status', store.status);
                    history.replaceState(null, '', url);

                }).then(function () {
                    vm.c.completed = true;
                });
        }
 // 实训平台预览地址
 var layerNum;
 $scope.createLink = function () {
     if (!clipboard) {
         clipboard = initClipboard();
     }

     layerNum = layer.open({
         type: 1,
         title: '实训平台预览地址',
         area: ['400px', '160px'],
         content: $('#address-copy-success'),
         skin: 'layui-tip'
     });

     // $scope.previewLink = DSSX.host.protocol + '//' + DSSX.attr.previewModeHost;
     if(DSSX.APP_CONFIG.dev.previewMethod && DSSX.APP_CONFIG.dev.previewMethod == 'cookie'){
         $scope.previewLink = DSSX.host.protocol + '//' + DSSX.host.main+ '/pub/api/back2MyAlibaba?tag='+DSSX.attr.previewPrefix.split('.')[0];
     }else{
         $scope.previewLink = DSSX.host.protocol + '//' + DSSX.attr.previewModeHost;
     }
     // $scope.previewLink = DSSX.host.protocol + '//' + DSSX.host.main+ '/pub/api/back2MyAlibaba?tag='+DSSX.attr.previewPrefix.split('.')[0];
 };

 $scope.closePreviewLinkLayer = function () {
     layer.close(layerNum);
 };
        // load list 开始
        function loadListOnStart() {
            vm.d.products = [];
        }

        // 加载我的产品
        function loadMyProducts(params) {
            return request.get('/usr/api/listMyProduct', params, true)
                .then(callback, errCallback);

            function callback(res) {
                var result = {
                    list: [],
                    count: [],
                    total: 0,
                    params: params
                };
                var products = util.safe(res, 'data.products', []);
                var draftCount = util.safe(res, 'data.draftCount', 0);
                var verifiedCount = util.safe(res, 'data.verifiedCount', 0);
                var verifiedTotal = util.safe(res, 'data.verifiedTotal', 0);
                var showWinIds = util.safe(res, 'data.showWinIds', 0);

                result.total = params.status === 'draft' ? draftCount : verifiedCount;
                result.count = [verifiedTotal, verifiedTotal, 0, 0, draftCount];

                for (var i = 0; i < products.length; i++) {
                    var p = {
                        id: products[i].id || '',
                        detailInfoUrl: products[i].numCommit ? 'product-detail.html?productId=' + products[i].id : '',
                        editUrl: 'product-post.html?productId=' + products[i].id,
                        copyUrl: 'product-post.html?copyId=' + products[i].id,
                        productName: products[i].productName || '',
                        img: util.safe(products[i], 'imgs.0.url', 'images/product-manage/no_photo.gif'),
                        group: products[i].group || '',
                        model: products[i].model || '',
                        lastTime: $filter('date')(new Date(products[i].last), 'yyyy-MM-dd'),
                        putaway: products[i].putaway === 'yes' ? '已上架' : '已下架',
                        price: handlePrice(products[i].tradeInfo),
                        director: products[i].director || mainAccountName,
                        selected: false,
                        directlyOrder: products[i].directlyOrder,
                        directOrder: products[i].directlyOrder === 0 ? '非直接下单品': '直接下单品',
                        score: products[i].score,
                        exposure: products[i].exposure,
                        tradeInfo: products[i].tradeInfo,
                        isRts: products[i].logisticsInfo ? products[i].logisticsInfo.isRts : 'no',
                        showWin: showWinIds ? showWinIds.some(function(item) {
                            return item === products[i].id;
                        }) : false,
                    };
                    result.list.push(p);
                }
                return result;
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'product-manage.js',
                    funcName: 'loadMyProducts',
                    text: '加载我的产品失败'
                });
                return {
                    list: [],
                    count: [],
                    total: 0
                };
            }
        }

        // 加载内置的产品
        function loadListInManagePrd(loadMyProductsResult) {
            // 如果加载的真实产品已经达到规定的最大数量（分页pageCount），就不需要加载内置产品
            // if (loadMyProductsResult.list.length >= loadMyProductsResult.params.pageCount) {
            
            // 改为无论任何状态都加载
            if(false) {
                return loadMyProductsResult
            } else {
                var params = {}

                return request.get('/usr/api/listInManagePrd', params, true)
                    .then(callback, errCallback);

                function callback(res) {
                    var result = {
                        list: [],
                        count: [],
                        total: 0
                    };
                    vm.d.defaultProducts = res.data.products || [];
                    var products = util.safe(res, 'data.products', []);
                    var draftCount = util.safe(res, 'data.draftCount', 0);
                    var verifiedCount = res.data.total;
                    result.count = [verifiedCount, verifiedCount, 0, 0, draftCount];

                    // 总数相关，需要计算筛选出来的内置商品数量
                    result.total = 0;

                    // 如果请求数据为“审核不通过”、“审核中”、“草稿”，则不需要显示内置数据，因为内置数据肯定是已通过审核的
                    if (
                        loadMyProductsResult.params.status !== 'verify-no-pass' &&
                        loadMyProductsResult.params.status !== 'verifying' &&
                        loadMyProductsResult.params.status !== 'draft'
                    ) {
                        for (var i = 0; i < products.length; i++) {
                            var p = {
                                id: products[i].id || '',
                                detailInfoUrl: 'product-detail.html?productId=' + products[i].id,
                                editUrl: 'product-post.html?productId=' + products[i].id,
                                copyUrl: 'product-post.html?copyId=' + products[i].id,
                                productName: products[i].productName || '',
                                img: util.safe(products[i], 'imgs.0.url', 'images/product-manage/no_photo.gif'),
                                group: products[i].group || '',
                                model: products[i].model || '',
                                lastTime: $filter('date')(new Date(products[i].last), 'yyyy-MM-dd'),
                                putaway: products[i].putaway === 'yes' ? '已上架' : '已下架',
                                price: handlePrice(products[i].tradeInfo),
                                director: products[i].director || mainAccountName,
                                selected: false,
                                isDefaultProducts: true, // 用于标记默认内置产品
                                directlyOrder: products[i].directlyOrder,
                                directOrder: products[i].directlyOrder === 0 ? '非直接下单品': '直接下单品',
                                score: products[i].score,
                                exposure: products[i].exposure,
                                tradeInfo: products[i].tradeInfo,
                                isRts: 'no',
                                showWin: false,
                            };

                            // 如果按条件（产品名称、产品分组）搜索，则只显示符合条件的内置产品
                            // 内置产品的筛选在前端完成
                            // 条件：key, group, model, director, putaway, id, updateTime, directlyOrder, isRts, showWin, score
                            var push = true;
                            var params = loadMyProductsResult.params;

                            if(products[i].productName.indexOf(params.key) < 0) {
                                push = false;
                            }
                            if(products[i].group.indexOf(params.group) < 0) {
                                push = false;
                            }
                            if(products[i].model.indexOf(params.model) < 0) {
                                push = false;
                            }
                            if(params.director !== '' && products[i].director !== $("#directorSelect").find("option:selected").text()) {
                                push = false;
                            }
                            if(params.putaway !== 'all' && products[i].putaway !== params.putaway) {
                                push = false;
                            }
                            if(products[i].id.indexOf(params.id) < 0) {
                                push = false;
                            }
                            if(params.updateTime !== '' && ((new Date().getTime() - products[i].last) / 1000 / 60 / 60 / 24 > parseInt(params.updateTime))) {
                                push = false;
                            }
                            if(params.directlyOrder !== '' && products[i].directlyOrder != params.directlyOrder) {
                                push = false;
                            }
                            if(params.isRts !== '' && products[i].isRts !== params.isRts) {
                                push = false;
                            }
                            if(params.showWin !== '' && products[i].showWin !== params.showWin) {
                                push = false;
                            }

                            var score = params.score.split('-');
                            if(params.score !== '' && (parseInt(products[i].score) < parseInt(score[0]) || parseInt(products[i].score) >= parseInt(score[1]))) {
                                push = false;
                            }

                            if(push) {
                                result.list.push(p);
                                result.total++;
                            }
                        }
                    }

                    // 根据分页需要，显示部分或全部内置产品
                    var showDefaultProducts = []

                    for (var i = Math.max((loadMyProductsResult.params.page - 1)*loadMyProductsResult.params.pageCount - loadMyProductsResult.total, 0); i < Math.min(loadMyProductsResult.params.pageCount - loadMyProductsResult.list.length, result.list.length); i++) {
                        showDefaultProducts.push(result.list[i])
                    }
                    var extendData = {
                        list: loadMyProductsResult.list.concat(showDefaultProducts),
                        count: [
                            result.count[0] + loadMyProductsResult.count[0],
                            result.count[1] + loadMyProductsResult.count[1],
                            result.count[2] + loadMyProductsResult.count[2],
                            result.count[3] + loadMyProductsResult.count[3],
                            result.count[4] + loadMyProductsResult.count[4]
                        ],
                        total: result.total + loadMyProductsResult.total
                    }
                    return extendData
                }

                function errCallback(error) {
                    DSSX.dialog.err(error, {
                        moduleName: 'product-manage.js',
                        funcName: 'loadListInManagePrd',
                        text: '加载内置的产品失败'
                    });
                    return {
                        list: [],
                        count: [],
                        total: 0
                    };
                }
            }
        }

        // 处理价格
        function handlePrice(tradeInfo) {
            var quantityPrice = tradeInfo.quantityPrice || {};
            var unit = tradeInfo.measureUnit || '';

            if (unit) {
                unit = unit.slice(0, unit.indexOf('/'));
            }

            var result = [];
            for (var attr in quantityPrice) {

                if (quantityPrice[attr] !== '-') {
                    result.push(quantityPrice[attr]);
                }
            }

            if (!result.length) {
                return '-';
            }

            return result.length > 1
                ? ( tradeInfo.moneyKind || 'US') + ' $' + result[result.length - 1] + '-' + result[0] + '/' + unit
                : ( tradeInfo.moneyKind || 'US') + ' $' + result[0] + '/' + unit;
        }

        // 加载数据成功
        function loadListOnSuccess(data) {
            // vm.d.products = revertSelectStatus(data.list);
            vm.d.products = data.list;
            vm.d.total = data.total;
            resetSelectAllStatus();
            setTopNavTabsNumber(data.count);
        }

        // 保存已被选中的产品
        function saveSelectedProduct(prod) {
            resetSelectAllStatus();

            // if (prod.selected) {
            //     store.beUpdateProducts.push({id: prod.id});
            // } else {
            //     for (var i = 0; i < store.beUpdateProducts.length; i++) {
            //         if (prod.id === store.beUpdateProducts[i].id) {
            //             store.beUpdateProducts.splice(i, 1);
            //             break;
            //         }
            //     }
            // }
        }

        // 换页码后保留选中状态
        function revertSelectStatus(list) {
            var beUpdateProducts = store.beUpdateProducts;
            for (var i = 0; i < list.length; i++) {
                for (var j = 0; j < beUpdateProducts.length; j++) {
                    if (beUpdateProducts[j].id === list[i].id) {
                        list[i].selected = true;
                    }
                }
            }
            return list;
        }

        // 设置全部产品的选中状态
        function setAllProductStatus() {
            var products = vm.d.products;
            for (var i = 0; i < products.length; i++) {
                products[i].selected = vm.c.selectAll;
                // saveSelectedProduct(products[i]);
            }
        }

        // 重置全选状态
        function resetSelectAllStatus() {

            if (!vm.d.products.length) {
                vm.c.selectAll = false;
                return;
            }

            vm.c.selectAll = vm.d.products.every(function (item) {
                return item.selected;
            });
        }

        // 加载分组
        function loadMyGroups() {
            request.get('/usr/api/listProductGroup', {}, true)
                .then(callback, errCallback);

            function callback(res) {
                var groups = util.safe(res, 'data.groups', []);
                groups.push('未分组');
                var groupList = angular.copy(groups);
                groups.unshift('所有分组');
                vm.d.groups = groups;

                var list = [];
                for (var i = 0; i < groupList.length; i++) {
                    list.push({
                        name: groupList[i],
                        selected: false
                    });
                }
                vm.d.groupList = list;
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'product-manage.js',
                    funcName: 'loadMyGroups',
                    text: '加载我的分组失败'
                });
            }
        }

        // 显示分组下拉菜单
        function showGroupsMenu(e) {
            e.stopPropagation();
            closeAimGroupsListWindow();
        }

        // 选中分组完成
        function selectGroupFinish(item) {
            vm.d.group = item;
        }

        // 回车搜索
        function enterSearch(e) {
            var keycode = window.event ? e.keyCode : e.which;
            if (keycode === 13) {
                searchProducts();
            }
        }

        // 搜索产品
        function searchProducts() {
            vm.search.p.group = vm.d.group === '所有分组' ? '' : vm.d.group;
            vm.search.p.key = vm.d.keyword;
            vm.search.p.showWin = vm.d.advance.showWin?'yes':'';

            var productType = vm.d.advance.productType.split(',');
            vm.search.p.directlyOrder = productType[0]==='all'?'':productType[0];
            vm.search.p.isRts = productType[1]==='all'?'':productType[1];

            clearBeUpdateProducts();
            reloadList(1, store.PAGE_COUNT);
        }

        // 清空搜索内容
        function clearSearchContent() {
            vm.d.group = '所有分组';
            vm.d.keyword = '';
            vm.search.p.model = '';
            vm.search.p.director = '';
            vm.search.p.putaway = 'all';
            vm.search.p.score = '';
            vm.search.p.id = '';
            vm.search.p.updateTime = '';
            vm.d.advance.productType = 'all,all';
            vm.d.advance.isRts = '';
            vm.d.advance.showWin = '';
            searchProducts();
        }

        // 刷新
        function refresh() {
            searchProducts();
        }

        // 更新产品状态 上架 || 下架 要判断403
        function updateProduct(arg) {
            // var data = store.beUpdateProducts;
            var params;
            if (arg.key === 'putaway') {
                params = {
                    putaway: arg.status
                };
            } else {
                if (!store.aimGroup) {
                    return;
                }
                params = {
                    group: store.aimGroup
                };
            }
            // 选中的数据（包括我的产品和默认内置产品）
            var selectedData = getUpdateProducts();

            if (!selectedData.length) {
                updateDialogContent('noProd', '请至少选择一个产品');
                return;
            }

            // 我的产品id集
            var updataMyProductStatusData = []
            // 默认内置产品id集
            var updataDefaultProductStatusData = {
                pids: [],
                putaway: params.putaway || '',
                group: params.group || ''
            }

            // 分开我的产品id集和默认内置产品id集
            selectedData.forEach(function (v) {
                var isDefaultProductStatusData = false
                if (vm.d.defaultProducts && vm.d.defaultProducts.length) {
                    vm.d.defaultProducts.forEach(function (i) {
                        if (i.id === v.id) {
                            isDefaultProductStatusData = true
                        }
                    })
                }
                if (isDefaultProductStatusData) {
                    updataDefaultProductStatusData.pids.push(v.id)
                } else {
                    updataMyProductStatusData.push({
                        id: v.id,
                        putaway: params.putaway || '',
                        group: params.group || ''
                    })
                }
            })

            /*
                * 程序能走到这里证明肯定有需要更新的产品
                * 如果有我的产品的id，就更新我的产品，否则直接更新内置产品
             */
            if (updataMyProductStatusData.length > 0) {
                updataMyProductStatus(params, updataMyProductStatusData)
            } else {
                updataDefaultProductStatus({}, updataDefaultProductStatusData)
            }

            // 更新我的产品状态
            function updataMyProductStatus(params, data) {
                request.post('/usr/api/updateProductBatch', params, data, true)
                    .then(callback, errCallback);

                function callback(res) {
                    /*
                        * 程序能走到这里证明肯定有需要更新的产品，但是有可能只有我的产品，不一定有内置产品
                        * 如果有内置产品的id，就更新内置产品
                     */
                    if (updataDefaultProductStatusData.pids.length > 0) {
                        updataDefaultProductStatus({}, updataDefaultProductStatusData)
                    } else {
                        productionManageTMInterpolator()
                        clearBeUpdateProducts();
                        reloadList(1, store.PAGE_COUNT);
                    }
                }

                function errCallback(error) {
                    DSSX.dialog.err(error, {
                        moduleName: 'product-manage.js',
                        funcName: 'updateProduct',
                        text: '更新产品状态失败'
                    });
                }
            }

            // 更新默认内置产品状态
            function updataDefaultProductStatus(params, data) {
                request.post('/usr/api/updateInManagePrdBatch', params, data, true)
                    .then(callback, errCallback);

                function callback(res) {
                    productionManageTMInterpolator()
                    clearBeUpdateProducts();
                    reloadList(1, store.PAGE_COUNT);
                }

                function errCallback(error) {
                    DSSX.dialog.err(error, {
                        moduleName: 'product-manage.js',
                        funcName: 'updateProduct',
                        text: '更新产品状态失败'
                    });
                }
            }

        }

        // 更新遮罩层内容
        function updateDialogContent(type, msg) {
            vm.c.dialogContent.type = type;
            vm.c.dialogContent.tip = msg;
            vm.c.showTip = true;
        }

        // 获得要更新的产品
        function getUpdateProducts() {
            var result = [];
            var products = vm.d.products;
            for (var i = 0; i < products.length; i++) {
                if(products[i].selected) {
                    result.push({
                        id: products[i].id
                    });
                }
            }
            return result;
        }

        // 清空待更新的产品
        function clearBeUpdateProducts() {
            store.beUpdateProducts = [];
        }

        function deleteProductSingle(prod) {
            store.singleProd = prod;
            updateDialogContent('delete', '您确认要删除这些信息吗？');
        }

        // 删除产品
        function deleteProduct(prod, batchProds) {
            // 选中的数据（包括我的产品和默认内置产品）
            var data = getUpdateProducts();

            // 我的产品id集
            var deleteMyProductStatusData = []
            // 默认内置产品id集
            var deleteDefaultProductStatusData = {
                pids: [],
                delete: 'yes'
            }

            if (batchProds && batchProds.length) {
                // 分开我的产品id集和默认内置产品id集
                data.forEach(function (v) {
                    var isDefaultProductStatusData = false
                    vm.d.defaultProducts.forEach(function (i) {
                        if (i.id === v.id) {
                            isDefaultProductStatusData = true
                        }
                    })
                    if (isDefaultProductStatusData) {
                        deleteDefaultProductStatusData.pids.push(v.id)
                    } else {
                        deleteMyProductStatusData.push(v.id)
                    }
                })
            } else {
                // 分开我的产品id集和默认内置产品id集
                var isDefaultProductStatusData = false
                vm.d.defaultProducts.forEach(function (i) {
                    if (i.id === prod.id) {
                        isDefaultProductStatusData = true
                    }
                })
                if (isDefaultProductStatusData) {
                    deleteDefaultProductStatusData.pids.push(prod.id)
                } else {
                    deleteMyProductStatusData.push(prod.id)
                }
            }

            /*
                * 程序能走到这里证明肯定有需要删除的产品
                * 如果有我的产品的id，就删除我的产品，否则直接删除内置产品
             */
            if (deleteMyProductStatusData.length > 0) {
                deleteMyProduct(deleteMyProductStatusData)
            } else {
                deleteDefaultProduct(deleteDefaultProductStatusData)
            }

            // 删除我的产品
            function deleteMyProduct(data) {
                request.post('/usr/api/delProduct', {}, data, true)
                    .then(callback, errCallback);

                function callback(res) {
                    /*
                        * 程序能走到这里证明肯定有需要删除的产品，但是有可能只有我的产品，不一定有内置产品
                        * 如果有内置产品的id，就删除内置产品
                     */
                    if (deleteDefaultProductStatusData.pids.length > 0) {
                        updataDefaultProductStatus(deleteDefaultProductStatusData)
                            .then(function () {
                                closeTip();
                                store.singleProd = null;
                            });
                    } else {
                        clearBeUpdateProducts();
                        reloadList(1, store.PAGE_COUNT);
                        closeTip();
                        store.singleProd = null;
                    }
                }

                function errCallback(error) {
                    store.singleProd = null;
                    DSSX.dialog.err(error, {
                        moduleName: 'product-manage.js',
                        funcName: 'deleteProduct',
                        text: '删除产品失败'
                    });
                }
            }

            // 删除默认内置产品
            function deleteDefaultProduct(data) {
                request.post('/usr/api/updateInManagePrdBatch', {}, data, true)
                    .then(callback, errCallback);

                function callback(res) {
                    clearBeUpdateProducts();
                    reloadList(1, store.PAGE_COUNT);
                    closeTip();
                    store.singleProd = null;
                }

                function errCallback(error) {
                    store.singleProd = null;
                    DSSX.dialog.err(error, {
                        moduleName: 'product-manage.js',
                        funcName: 'deleteProduct',
                        text: '删除产品失败'
                    });
                }
            }

            // 更新默认内置产品状态 - 删除用
            function updataDefaultProductStatus(data) {
                return request.post('/usr/api/updateInManagePrdBatch', {}, data, true)
                    .then(callback, errCallback);

                function callback(res) {
                    clearBeUpdateProducts();
                    reloadList(1, store.PAGE_COUNT);
                }

                function errCallback(error) {
                    DSSX.dialog.err(error, {
                        moduleName: 'product-manage.js',
                        funcName: 'updateProduct',
                        text: '更新产品状态失败'
                    });
                    return $q.reject(error);
                }
            }
        }

        // 弹出删除提示
        function openDeleteTip() {
            var result = getUpdateProducts();

            if (result && result.length) {
                updateDialogContent('delete', '您确认要删除这些信息吗？');
                return;
            }

            updateDialogContent('noProd', '请至少选择一个产品');
        }

        // 批量删除
        function batchDetailProduct() {

            var result = getUpdateProducts();
            var data = [];
            for (var i = 0; i < result.length; i++) {
                data.push(result[i].id);
            }

            deleteProduct(store.singleProd, data);
        }

        // 批量修改
        function batchEditProduct() {
            var result = getUpdateProducts();
            var data = [];
            for (var i = 0; i < result.length; i++) {
                data.push(result[i].id);
            }
            window.open("/product-batch-edit.html?ids=" + data.toString());
        }

        // 设置每页显示的产品数
        function setPageCount(ps) {
            for (var i = 0; i < vm.c.pageCountFilter.length; i++) {
                vm.c.pageCountFilter[i].active = false;
            }
            ps.active = true;
            store.PAGE_COUNT = ps.number;
            reloadList(1, store.PAGE_COUNT);
        }// 重置数据
        function onResetDefaultData(){
            layer.open({
                type: 0,
                title: '重置默认数据',
                content: '重置默认数据后，产品管理模块默认数据将恢复为初始状态，已经删除,上架或者分配负责人的产品会被还原。如果已提交相关作答，建议确认批改完成后再进行重置，以免影响考核成绩',
                btn: ['确定', '取消'],
                btnAlign: 'l',
                area: ['360px', 'auto'],
                skin: 'layui-tip',
                yes: function(index) {
                    resetDefaultData().then(
                        function(){
                            layer.close(index);
                        }
                    )
                }
            });
        }

        // 重置数据
        function resetDefaultData(){
            vm.c.completed = false;
            var params = {
                reset: 'yes'
            }
            return request.post('/usr/api/updateInManagePrdBatch', {}, params, true)
                .then(callback, errCallback);

            function callback(res) {
                layer.msg('重置成功', {icon: 1});
                clearBeUpdateProducts();
                reloadList(1, store.PAGE_COUNT);
                return res;
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'product-manage.js',
                    funcName: 'resetDefaultData',
                    text: '重置数据失败'
                });
                vm.c.completed = true;
            }
        }


        // 选中要移到到的目标分组
        function selectGroup(event, group) {
            event.stopPropagation();
            resetAimGroupStatus();
            group.selected = true;
            store.aimGroup = group.name;
        }

        function resetAimGroupStatus() {
            var groupList = vm.d.groupList;
            for (var i = 0; i < groupList.length; i++) {
                groupList[i].selected = false;
            }
        }

        // 显示移动到 分组列表
        function ctrlAimGroupsList(event) {
            event.stopPropagation();
            vm.c.showAimGroupsSelect = !vm.c.showAimGroupsSelect;

            if (!vm.c.showAimGroupsSelect) {
                resetAimGroupStatus();
            }
        }

        // 关闭分组选择 （移动）
        function closeAimGroupsListWindow() {
            store.aimGroup = '';
            resetAimGroupStatus();
        }

        function initDocumentEvent() {
            $(document).on('click', function () {
                closeAimGroupsListWindow();
            })
        }

        function closeTip() {
            vm.c.showTip = false;
        }

        function paginationSyncFunc() {

        }

        function showNotReleaseTip(url, isDefaultProducts) {
            if (!url && !isDefaultProducts) {
                layer.open({
                    title: '温馨提示',
                    area: ['400px', '200px'],
                    content: '<div style="padding: 20px;">该产品还没有发布，发布后即可查看详情。</div>',
                    btn: ['关闭']
                });
            }
        }

        // 加载子账号
        function loadSubAccountList() {
            return request.get('/usr/api/listSubAccount', {myName: 1, type: 'salesman,businessManager'}, true)
                .then(callback, errCallback);

            function callback(res) {
                mainAccountName = $.trim(res.data.myName) || 'null null';
                var list = util.safe(res, 'data.subAccounts', []);

                list = list.map(function (item) {
                    return {
                        id: item.id,
                        nickName: util.safe(item, 'name.firstName', '') + ' ' + util.safe(item, 'name.lastName', '')
                    }
                });

                list.push({id: 'ME', nickName: mainAccountName});
                vm.d.subAccounts = list;

                // 高级搜索配置-产品负责人列表
                vm.c.advanceConf.director = angular.copy(list);
                vm.c.advanceConf.director.unshift({id: '', nickName: '全部'});
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: '询价单管理',
                    funcName: 'loadSubAccountList',
                    text: 'loadSubAccountList fail'
                });
                $q.reject(error);
            }
        }

        function allotProd(item) {

            var data = getUpdateProducts();

            if (!data.length) {
                updateDialogContent('noProd', '请至少选择一个产品');
                return;
            }

            //需要更新的真实产品的id数组
            var realProductsId = []
            //需要更新的内置产品的id数组
            var defaultProductsId = []

            // 分开我的产品id集和默认内置产品id集
            data.forEach(function (v) {
                var isdefaultProducts = false // 当前遍历的产品是否内置产品
                vm.d.defaultProducts.forEach(function (i) {
                    if (i.id === v.id) {
                        isdefaultProducts = true
                    }
                })
                if (isdefaultProducts) {
                    defaultProductsId.push(v.id)
                } else {
                    realProductsId.push(v.id)
                }
            })

            if (realProductsId.length > 0) {
                updateProductBatch()
            } else {
                updataDefaultProductStatus({
                    director: item.id,
                    pids: defaultProductsId
                })
            }

            function updateProductBatch() {
                request.post('/usr/api/updateProductBatch', {director: item.id}, data, true)
                    .then(callback, errCallback);

                function callback(res) {
                    // 如果有需要更新的内置产品，就继续更新内置产品
                    if (defaultProductsId.length > 0) {
                        updataDefaultProductStatus({
                            director: item.id,
                            pids: defaultProductsId
                        })
                    } else {
                        productionManageTMInterpolator()
                        clearBeUpdateProducts();
                        reloadList(1, store.PAGE_COUNT);
                    }
                }

                function errCallback(err) {
                    DSSX.dialog.err(err, {
                        moduleName: 'product-manage.js',
                        funcName: 'allotProd',
                        text: 'allotProd fail'
                    });
                }
            }

            // 更新默认内置产品状态
            function updataDefaultProductStatus(data) {
                request.post('/usr/api/updateInManagePrdBatch', {}, data, true)
                    .then(callback, errCallback);

                function callback(res) {
                    productionManageTMInterpolator()
                    clearBeUpdateProducts();
                    reloadList(1, store.PAGE_COUNT);
                }

                function errCallback(error) {
                    DSSX.dialog.err(error, {
                        moduleName: 'product-manage.js',
                        funcName: 'updateProduct',
                        text: '更新产品状态失败'
                    });
                }
            }
        }

        // 实训任务-产品管理 插入逻辑
        function productionManageTMInterpolator() {
            var TM = DSSX.TrainingMission;

            return TM.tryStart(TM.MissionType.Product_Manage, {bindId: '', bindInfo: ''})
                .then(tryStartTMSuc, tryStartTMErr);

            function tryStartTMSuc(tmc) {

            }

            function tryStartTMErr(err) {
                console.log('[TM] tryStartTMErr', err);
            }
        }

        // 初始化价格编辑器并显示
        function showPriceEditor(id, mode) {
            var product = vm.d.products.filter(function(item) {
                return item.id === id;
            })[0];

            if(product.tradeInfo.priceSetting === 'fob') {
                // 计算fob价
                var quantityPrice = [{
                    order: '',
                    price: '',
                }];

                for(var i in product.tradeInfo.quantityPrice) {
                    var price = product.tradeInfo.quantityPrice[i].split('-');
                    var fobPrice = {
                        order: i,
                        minPrice: price[0],
                        maxPrice: price[1],
                        orderErrMsg: '',
                        priceErrMsg: '',
                    };
                    break;
                }
            } else {
                // 计算阶梯价
                var fobPrice = {};
                var quantityPrice = [];

                for(var i in product.tradeInfo.quantityPrice) {
                    quantityPrice.push({
                        order: i,
                        price: product.tradeInfo.quantityPrice[i],
                    })
                }
            }
            
            // 价格编辑窗对象
            vm.d.priceEditor = {
                isShow: true, // 是否展示弹窗
                mode: mode, // small：小窗，仅修改价格 big：大窗，修改规格信息
                id: product.id, // api所需
                tradeInfo: product.tradeInfo, // 当前产品的原tradeInfo，api所需
                directlyOrder: product.directlyOrder, // 展示用途
                measureUnit: product.tradeInfo.measureUnit, // 展示用途
                priceSetting: product.tradeInfo.priceSetting, // 展示用途
                fobPrice: fobPrice, // 数据绑定用途
                quantityPrice: quantityPrice, // 数据绑定用途
                moneyKind: product.tradeInfo.moneyKind, // 数据绑定用途
                preview: {}, // 预览相关对象，展示用途
            }

            setPriceEditorPreview();
        }

        // 控制价格编辑器价格区间数量
        function ctrlPriceEditor(mode, index) {
            if(mode === 'add') {
                if(vm.d.priceEditor.quantityPrice.length >= 4) {
                    return;
                }

                vm.d.priceEditor.quantityPrice.push({
                    order: '',
                    price: '',
                })
            } else {
                vm.d.priceEditor.quantityPrice.splice(index, 1);
            }

            setPriceEditorPreview();
        }

        // 设置价格编辑器预览，非单一fob区间价格才有预览
        function setPriceEditorPreview() {
            checkPriceEditorInput();

            if(vm.d.priceEditor.priceSetting !== 'fob' && vm.d.priceEditor.preview.errMsg.length == 0) {
                vm.d.priceEditor.preview.data = vm.d.priceEditor.quantityPrice.map(function(item, index) {
                    var nextItem = vm.d.priceEditor.quantityPrice[index + 1];
                    var order = nextItem ? item.order + '~' + (nextItem.order - 1) : '≥' + item.order;
                    
                    return {
                        order: order,
                        price: item.price,
                    }
                });
            }
        }

        // 检查起订量与价格格式
        function checkPriceEditorInput() {
            var orderReg = /^[1-9]\d*$/;
            var priceReg = /^[0-9]+(\.[0-9]{1,2})?$/;

            if(vm.d.priceEditor.priceSetting === 'fob') {
                var fobPrice = vm.d.priceEditor.fobPrice;
                fobPrice.orderErrMsg = '';
                fobPrice.priceErrMsg = '';

                var ret = false;
    
                if(!orderReg.test(fobPrice.order)) {
                    fobPrice.orderErrMsg = '无效起订量：请输入1-999999999的整数';
                    ret = true;
                }
                
                if(!priceReg.test(fobPrice.minPrice)) {
                    fobPrice.priceErrMsg = '无效价格：请输入0.0001-999999999.9999之间的数值, 并精确到小数点后2位';
                    ret = true;
                }
                
                if(!priceReg.test(fobPrice.maxPrice)) {
                    fobPrice.priceErrMsg = '无效价格：请输入0.0001-999999999.9999之间的数值, 并精确到小数点后2位';
                    ret = true;
                }

                if(ret) {
                    return;
                }
    
                var order = parseInt(fobPrice.order);
                var minPrice = parseFloat(fobPrice.minPrice);
                var maxPrice = parseFloat(fobPrice.maxPrice);
    
                if(order < 1 || order > 999999999) {
                    fobPrice.orderErrMsg = '无效起订量：请输入1-999999999的整数';
                }

                if(minPrice < 0.01 || minPrice > 999999999.99) {
                    fobPrice.priceErrMsg = '无效价格：请输入0.0001-999999999.9999之间的数值, 并精确到小数点后2位';
                }

                if(maxPrice < 0.01 || maxPrice > 999999999.99) {
                    fobPrice.priceErrMsg = '无效价格：请输入0.0001-999999999.9999之间的数值, 并精确到小数点后2位';
                }

                if(maxPrice <= minPrice) {
                    fobPrice.priceErrMsg = '最大价格必须大于最小价格';
                }
            }
            else {
                var prevOrder = -1;
                var prevPrice = -0.1;
                var errMsg = new Set();
                vm.d.priceEditor.quantityPrice.forEach(function(item, index) {
                    var ret = false;
    
                    if(!orderReg.test(item.order)) {
                        errMsg.add('无效起订量：请输入1-999999999的整数');
                        ret = true;
                    }
                    
                    if(!priceReg.test(item.price)) {
                        errMsg.add('无效价格：请输入0.0001-999999999.9999之间的数值, 并精确到小数点后2位');
                        ret = true;
                    }
    
                    if(ret) {
                        return;
                    }
    
                    var order = parseInt(item.order);
                    var price = parseFloat(item.price);
    
                    if(order < 1 || order > 999999999) {
                        errMsg.add('无效起订量：请输入1-999999999的整数');
                    }
    
                    if(price < 0.01 || price > 999999999.99) {
                        errMsg.add('无效价格：请输入0.01-999999999.99之间的数值, 并精确到小数点后2位');
                    }
    
                    if(index && order <= prevOrder) {
                        errMsg.add('起订量必须是由小到大');
                    }
    
                    if(index && price >= prevPrice) {
                        errMsg.add('价格必须是由大到小');
                    }
    
                    prevOrder = order;
                    prevPrice = price;
                })
                vm.d.priceEditor.preview = {
                    data: [],
                    errMsg: Array.from(errMsg),
                }
            }
        }

        // 更新产品的tradeInfo
        function updateProductTradeInfo() {
            checkPriceEditorInput();

            // 初始化新的tradeInfo，更新其quantityPrice
            var editorData = vm.d.priceEditor
            var tradeInfo = angular.copy(editorData.tradeInfo);
            tradeInfo.quantityPrice = {};

            if(editorData.priceSetting === 'fob') {
                // 存在错误，不允许提交，直接返回
                if(editorData.fobPrice.orderErrMsg !== '' || editorData.fobPrice.priceErrMsg !== '') {
                    return;
                }

                // 单一fob区间价格
                tradeInfo.quantityPrice[editorData.fobPrice.order] = editorData.fobPrice.minPrice + "-" + editorData.fobPrice.maxPrice;
                tradeInfo.moneyKind = editorData.moneyKind;
            } else {
                // 存在错误，不允许提交，直接返回
                if(editorData.preview.errMsg.length !== 0) {
                    return;
                }

                // 非单一fob区间价格
                editorData.quantityPrice.forEach(function(item) {
                    tradeInfo.quantityPrice[item.order] = item.price;
                })
            }
                
            var requestData = [{
                id: editorData.id,
                tradeInfo: tradeInfo
            }];

            if(editorData.mode === 'big') {
                //修改规格信息，需要修改priceSetting
                tradeInfo.priceSetting = editorData.priceSetting;
            }
            
            request.post('/usr/api/updateProductBatch', {}, requestData, true)
                .then(callback, errCallback);

            function callback(res) {
                reloadList(1, store.PAGE_COUNT);
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'product-manage.js',
                    funcName: 'updateProduct',
                    text: '更新产品状态失败'
                });
            }

            editorData.isShow = false;
        }

        // 高级搜索切换产品类型
        function changeFilterDirectlyOrder() {
            if(vm.d.advance.productType === "1,yes") {
                vm.d.advance.isRts = true;
            } else {
                vm.d.advance.isRts = false;
            }
        }

        // 高级搜索选中 Ready to ship
        function clickFilterIsRTS() {
            if(vm.d.advance.isRts) {
                vm.d.advance.productType = '1,yes';
            } else {
                vm.d.advance.productType = 'all,all';
            }
        }

        // 切换多语言市场
        function changeMarket() {
            $timeout(function () {
                if(vm.c.marketId !== 'EN') {
                    location.href = '/multi-lang-market.html#!/product-manage/' + vm.c.marketId
                }
            });
        }
    }
})();
